<template>
  <div class="m-auto mb-24 max-w-[768px] md:border">
    <div class="min-h-screen">
      <router-view :key="routeKey"></router-view>
    </div>

    <footer-bar />
  </div>
</template>

<script setup>
import { computed, onMounted, onUnmounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useSettingsStore } from '@/app/stores/settings'
import { useUserStore } from '@/app/stores/user'
import { useXardsStore } from '@/app/stores/xards'
import FooterBar from './components/FooterBar.vue'
import { storeToRefs } from 'pinia'

const router = useRouter()
const route = useRoute()
const settingsStore = useSettingsStore()
const xardsStore = useXardsStore()
const userStore = useUserStore()

settingsStore.loadSettings()
userStore.loadUser()
const { selectedXards } = storeToRefs(xardsStore)

const routeKey = computed(() => {
  if (!route.hash || !route.hash.length) {
    return route.fullPath
  }
  return route.fullPath.replace(route.hash, '')
})

function onMessage(event) {
  if (event.data?.type === 'clearXardSelection') {
    selectedXards.value = []
  } else if (event.data?.type === 'navigation') {
    router.push({
      name: 'xards',
      query: { filters: event.data.filters }
    })
  }
}

onMounted(() => {
  window.addEventListener('message', onMessage)
})

onUnmounted(() => {
  window.removeEventListener('message', onMessage)
})

window.performFTShare = function () {
  return JSON.stringify({
    result: true,
    query: window.getSelection().toString(),
    xards: selectedXards.value
  })
}
</script>
